import { MaskedLine } from "@/components/Reveal";
import { CLOSING } from "@/data/content";

const WaveDivider = () => (
  <svg
    viewBox="0 0 1440 60"
    fill="none"
    className="mx-auto mb-16 w-full max-w-3xl"
    aria-hidden="true"
  >
    <path
      d="M0 30 C 240 0, 480 60, 720 30 C 960 0, 1200 60, 1440 30"
      stroke="#0F3D81"
      strokeWidth="1.5"
      strokeOpacity="0.6"
    />
  </svg>
);

export const Closing = () => (
  <section
    data-testid="closing-section"
    className="noise relative bg-navy-ink py-24 md:py-32"
  >
    <div className="mx-auto w-full max-w-7xl px-6 text-left md:px-12">
      <WaveDivider />
      <h2 className="font-display text-4xl font-bold uppercase leading-[1.02] tracking-tight text-white sm:text-5xl lg:text-6xl">
        <MaskedLine>
          <span>{CLOSING.headlineLines[0]}</span>
        </MaskedLine>
        <MaskedLine delay={0.15}>
          <span style={{ color: "#7FA8E8" }}>{CLOSING.headlineLines[1]}</span>
        </MaskedLine>
      </h2>
    </div>
  </section>
);
